export enum FlagTimeslice {
	DATE_31 = 6,
	DATE_30 = 5,
	DATE_29 = 4,
	REPETITION_ANNUAL = 3,
	REPETITION_MONTHLY = 2,
	TEMPORARY = 1,
	ESCLUDE_INCLUDE = 0
}